import styled from 'styled-components';
import { Stack, Text, Button, Icon } from '@appcues/sonar';

export const StyledConfigurationCard = styled(Stack)`
  background-color: var(--background-level-1);
  padding: var(--spacing-x-large) var(--spacing-large);
  border-radius: var(--border-radius-small);
  width: 100%;
  box-shadow: var(--elevation-100);
`;

export const Image = styled.img`
  width: 160px;
`;

export const ContainedText = styled(Text)`
  max-width: 400px;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  display: inline-block;
  text-decoration: none;
`;

export const CustomIcon = styled(Icon)`
  width: 16px;
  height: 16px;
`;
